import { render, staticRenderFns } from "./accountTHINKTab.vue?vue&type=template&id=35ee0012&scoped=true&"
import script from "./accountTHINKTab.vue?vue&type=script&lang=js&"
export * from "./accountTHINKTab.vue?vue&type=script&lang=js&"
import style0 from "./accountTHINKTab.vue?vue&type=style&index=0&id=35ee0012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee0012",
  null
  
)

export default component.exports